import React from 'react';
import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';
import BodyText from 'src/presentation/components/ui/BodyText';

interface ComponentProps {
  error: string;
}

const StyledBodyText = styled(BodyText)`
  ${() => css`
    padding: 4px 16px;
  `}
`;

const ErrorText = ({ error }: ComponentProps) => {
  return <StyledBodyText color={colors.primaryRed} level={'b3-reg'}>{error}</StyledBodyText>;
};

export default ErrorText;
